var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavMatters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15119 6.26699C2.81647 6.26699 2.54513 6.53562 2.54513 6.86699V12.867C2.54513 13.1984 2.81647 13.467 3.15119 13.467H12.8482C13.1829 13.467 13.4542 13.1984 13.4542 12.867V6.86699C13.4542 6.53562 13.1829 6.26699 12.8482 6.26699H3.15119ZM1.33301 6.86699C1.33301 5.87288 2.14704 5.06699 3.15119 5.06699H12.8482C13.8523 5.06699 14.6663 5.87288 14.6663 6.86699V12.867C14.6663 13.8611 13.8523 14.667 12.8482 14.667H3.15119C2.14704 14.667 1.33301 13.8611 1.33301 12.867V6.86699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5019 3.1942C5.84288 2.85663 6.30534 2.66699 6.78755 2.66699H9.2118C9.69401 2.66699 10.1565 2.85663 10.4974 3.1942C10.8384 3.53177 11.03 3.9896 11.03 4.46699V14.067C11.03 14.3984 10.7586 14.667 10.4239 14.667C10.0892 14.667 9.81786 14.3984 9.81786 14.067V4.46699C9.81786 4.30786 9.754 4.15525 9.64035 4.04273C9.52669 3.93021 9.37253 3.86699 9.2118 3.86699H6.78755C6.62682 3.86699 6.47266 3.93021 6.359 4.04273C6.24535 4.15525 6.18149 4.30786 6.18149 4.46699V14.067C6.18149 14.3984 5.91015 14.667 5.57543 14.667C5.24071 14.667 4.96937 14.3984 4.96937 14.067V4.46699C4.96937 3.9896 5.16093 3.53177 5.5019 3.1942Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMatters);
export default __webpack_public_path__ + "static/media/nav-matters.155b30910dcea4b272eb28b015d7e601.svg";
export { ForwardRef as ReactComponent };